import { inject } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { AuthService, isAuthRedirectContext } from '@pecan/core';
import { PermissionsFacade } from '@pecan/entities/permissions';
import { type Observable, of } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';

export function initializeApp(): Observable<unknown> {
    if (isAuthRedirectContext()) {
        return of(null);
    }

    const msal = inject(MsalService);
    const broadcast = inject(MsalBroadcastService);
    const permissionsFacade = inject(PermissionsFacade);
    const authService = inject(AuthService);

    return msal.initialize().pipe(
        switchMap(() => msal.handleRedirectObservable()),
        switchMap(() =>
            broadcast.inProgress$.pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                take(1)
            )
        ),
        switchMap(() => authService.getAuthenticationToken()),
        filter(Boolean),
        switchMap(() => permissionsFacade.loadPermissions()),
        catchError((error: unknown) => {
            console.error('App initialization failed', error);

            return of(null);
        })
    );
}
